// 展示会ごとの設定
export const exhibitions = {
  SPORTEC2023: {
    remainMailSubject: "[SPORETEC2023] 出展社バッジ申請のお願い",
  },
  CAFERES2023: {
    remainMailSubject: "[CAFERES2023] 出展社バッジ申請のお願い",
  },
}

// TODO: 設定から取得する汎用的な関数があると便利かも
export const exhibitionsRemindMailSubject: {[key: string]: string} = {
  SPORTEC2023: exhibitions.SPORTEC2023.remainMailSubject,
  CAFERES2023: exhibitions.CAFERES2023.remainMailSubject,
}
